import { FormCheckbox } from '@/components/forms/form-checkbox.js';
import { FormComboBox } from '@/components/forms/form-combo-box.js';
import { FormInputField } from '@/components/forms/form-input-field.js';
import { comboBoxOptionsOf } from '@/components/ui/multi-select-utils.js';
import { getTimezoneTypeahead } from '@/lib/time-zones.js';
import { CreateCoachFormSchema } from '@/routes/_layout/teachers/-components/form-schema.js';
import { UseFormReturn } from 'react-hook-form';

export function CreateCoachForm({
  form,
  disabled,
}: {
  form: UseFormReturn<CreateCoachFormSchema>;
  disabled?: boolean;
}) {
  return (
    <>
      <FormInputField
        name="firstName"
        label="First Name"
        form={form}
        inputProps={{ required: true, className: 'w-[80%]', disabled }}
      />
      <FormInputField
        name="lastName"
        label="Last Name"
        form={form}
        inputProps={{ required: true, className: 'w-[80%]', disabled }}
      />
      <FormInputField
        name="email"
        label="Email"
        form={form}
        inputProps={{ required: true, className: 'w-[80%]', type: 'email', disabled }}
      />
      <FormInputField
        name="phone"
        label="Phone"
        form={form}
        className=""
        inputProps={{ required: true, className: 'w-[80%]', type: 'tel', disabled }}
      />
      <FormCheckbox
        name="smsReminderOptedIn"
        label="SMS text reminder"
        form={form}
        checkboxProps={{ required: true, defaultChecked: true, disabled }}
      />
      <FormComboBox
        name="timeZone"
        label="Time zone"
        form={form}
        {...comboBoxOptionsOf(getTimezoneTypeahead)}
        triggerProps={{ className: 'w-[80%]', disabled }}
        required
      />
      <FormInputField
        name="displayName"
        label="Display name for students"
        form={form}
        inputProps={{ required: true, className: 'w-[80%]', disabled }}
      />
      <FormInputField
        name="secondaryEmail"
        label="Secondary email"
        form={form}
        inputProps={{ className: 'w-[80%]', type: 'email', disabled }}
      />
    </>
  );
}
